<template>

  <div>
    <ul
      class="list-group"
      v-sortable="{ items: selected }">
      <li
        class="list-group-item move"
        v-for="(item, index) in selected"
        :key="index">
        <div class="d-flex">
          <div class="mr-2">
            <i class="fas fa-arrows-alt" />
          </div>
          <div class="w-100">{{ item.label }}</div>
          <div class="ml-2">
            <a
              href="javascript:void(0)"
              @click="removeItem(index)">{{ $t('Remove') }}</a>
          </div>
        </div>
      </li>
    </ul>

    <button
        class="btn btn-sm btn-block btn-light dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        Adicionar campo
      </button>
      <div
        class="dropdown-menu"
        aria-labelledby="dropdownMenuButton"
        style="overflow: auto; max-height: 200px">
        <button
          type="button"
          v-for="(item, index) in noSelected"
          :key="index"
          class="dropdown-item"
          @click="addItem(item)">
          {{ item.label }}
          </button>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'SelectColumns',
  props: {
    value: {
      type: Array,
      default: () => { return [] }
    },
    placeholder: {
      type: String
    },
    options: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      selected: this.options.filter(val => this.value.includes(val.value))
    }
  },
  watch: {
    selected (val) {
      this.change(val)
    }
  },
  computed: {
    noSelected () {
      return this.options.filter(item => {
        return Array.isArray(this.value) && !this.value.includes(item.value)
      })
    }
  },
  methods: {
    change (val) {
      const values = val.map(v => v.value)
      this.$emit('input', values)
    },
    addItem (item) {
      this.selected.push(item)
    },
    removeItem (index) {
      this.selected.splice(index, 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectColumns.vue